export default __webpack_public_path__ + "static/media/057-contract-1.cd7a7b1e.svg";